import { apiLoadSettings, apiSaveSettings } from "./baseApi"

// Section name matches the AdminAjax action names exactly:
// load_rush_surcharge_settings / save_rush_surcharge_settings.
export const apiSaveRushSurchargeSettings = (data, callback) => {
  apiSaveSettings(data, callback, 'rush_surcharge')
}

export const apiLoadRushSurchargeSettings = (callback) => {
  apiLoadSettings(callback, 'rush_surcharge')
}
